import React from 'react';

import ModalComponent from '../../ModalComponent/ModalComponent';

import './_shortcutsModal.scss';

import NewShortcutComponent from './NewShortcutComponent';
import OldShortcutComponent from './OldShortcutComponent';

const ShortcutsModal = ({ show, onClose, keysData, title, isNewShortcut = false, width = 385, topCross = false }) => {
  return (
    <ModalComponent show={show} onClose={onClose} width={width} noPadding topCross={topCross} outsideClickClose={false}>
      {isNewShortcut ? (
        <NewShortcutComponent keysData={keysData} title={title} onClose={onClose} />
      ) : (
        <OldShortcutComponent keysData={keysData} title={title} onClose={onClose} />
      )}
    </ModalComponent>
  );
};

export default ShortcutsModal;
